import { Grid, Skeleton } from "@mui/material";
import React from "react";

/** Large number placeholder for metric cards (matches OrderAnalytic value row) */
export function MetricValueSkeleton() {
  return (
    <Skeleton
      variant="rounded"
      animation="wave"
      width={96}
      height={30}
      sx={{ borderRadius: "4px", flexShrink: 0 }}
    />
  );
}

/** Donut + legend placeholder */
export function PieChartSkeleton() {
  return (
    <Grid container alignItems="center" sx={{ height: "100%", px: 1, py: 0.5 }}>
      <Grid item sx={{ width: "42%", display: "flex", justifyContent: "center" }}>
        <Skeleton variant="circular" width={88} height={88} />
      </Grid>
      <Grid
        item
        container
        direction="column"
        rowGap={0.75}
        sx={{ flex: 1, pl: 1 }}
      >
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} variant="rounded" height={14} width={`${55 + i * 8}%`} />
        ))}
      </Grid>
    </Grid>
  );
}

/** Bar chart placeholder */
export function BarChartSkeleton() {
  const heights = [40, 55, 35, 60, 45, 50, 38, 48];
  return (
    <Grid
      container
      alignItems="flex-end"
      justifyContent="space-between"
      sx={{ height: 140, px: 1, pt: 1, pb: 2.5 }}
    >
      {heights.map((h, i) => (
        <Skeleton
          key={i}
          variant="rounded"
          sx={{ width: "8%", height: h, borderRadius: "4px 4px 0 0" }}
        />
      ))}
    </Grid>
  );
}

/** Area / line chart placeholder */
export function AreaChartSkeleton() {
  const barHeights = [32, 48, 40, 72, 56, 64, 44];
  return (
    <Grid
      container
      alignItems="flex-end"
      justifyContent="space-between"
      sx={{ height: 180, px: 2, py: 1 }}
    >
      {barHeights.map((h, i) => (
        <Skeleton
          key={i}
          variant="rounded"
          sx={{
            width: "11%",
            height: h,
            maxHeight: 120,
            borderRadius: "6px 6px 2px 2px",
          }}
        />
      ))}
    </Grid>
  );
}

/** Search row under 30 days card */
export function UpcomingShowsToolbarSkeleton() {
  return (
    <Grid container columnGap={0.5} p={1} alignItems="center">
      <Skeleton variant="rounded" height={40} sx={{ flex: 1, borderRadius: 1 }} />
      <Skeleton variant="rounded" width={40} height={40} sx={{ borderRadius: 1 }} />
    </Grid>
  );
}

/** Upcoming shows list rows */
export function UpcomingShowsListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <Grid container direction="column" sx={{ px: 1, py: 0.5 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Grid
          key={i}
          container
          alignItems="center"
          columnGap={1}
          sx={{
            py: 1.25,
            borderBottom: "var(--cuo-border-soft)",
          }}
        >
          <Skeleton variant="rounded" width={50} height={63} />
          <Grid container direction="column" flex={1} rowGap={0.5}>
            <Skeleton variant="text" width="75%" height={22} />
            <Skeleton variant="text" width="45%" height={16} />
            <Skeleton variant="rounded" width="100%" height={7} sx={{ mt: 0.5 }} />
          </Grid>
          <Skeleton variant="rounded" width={50} height={50} />
        </Grid>
      ))}
    </Grid>
  );
}
